import React from 'react';
import InlineIconsData from './svg-data.js';

const SpriteIcon = props => {
  const iconProps = {
    fill: props.color || 'currentColor',
    height: props.height || null,
    width: props.width || '100%'
  };
  return (
    <svg {...iconProps} className={props.className}>
      <use xlinkHref={`#${props.name}`} />
    </svg>
  );
};

const Icon = props => {
  if (!props.name) {
    return null;
  }

  const iconProps = {
    fill: props.color || 'currentColor',
    height: props.height || 'auto',
    width: props.width || '100%',
    display: 'block'
  };

  if (typeof InlineIconsData[props.name] === 'undefined') {
    return <SpriteIcon {...props} />;
  }
  if (Array.isArray(InlineIconsData[props.name])) {
    return (
      <svg
        style={{ ...iconProps }}
        viewBox={InlineIconsData[props.name][0]}
        className={props.classNname}
      >
        <path d={InlineIconsData[props.name][1]} />
      </svg>
    );
  }

  return InlineIconsData[props.name](iconProps);
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/index.js